import { useCallback, useEffect, useState } from 'react';
import { useApi } from './useApi';

// Module-level cache — один запрос на всю сессию приложения.
let _cache = null;
let _pending = null;

function flattenTools(sections) {
    const map = {};
    (sections || []).forEach(sec => {
        (sec.modules || []).forEach(mod => {
            (mod.tools || []).forEach(t => { map[t.key] = t; });
        });
        (sec.direct_tools || []).forEach(t => { map[t.key] = t; });
    });
    return map;
}

export function useToolManual() {
    const { request } = useApi();
    const [sections, setSections] = useState(_cache?.sections || []);
    const [toolsMap, setToolsMap] = useState(_cache ? flattenTools(_cache.sections) : {});
    const [loading, setLoading] = useState(!_cache);

    const load = useCallback(async () => {
        if (_cache) {
            setSections(_cache.sections || []);
            setToolsMap(flattenTools(_cache.sections));
            setLoading(false);
            return;
        }
        if (!_pending) {
            _pending = request('/api/v1/billing/tool-manual')
                .then(res => { _cache = res; return res; })
                .catch(() => { _cache = { sections: [] }; return _cache; })
                .finally(() => { _pending = null; });
        }
        setLoading(true);
        const res = await _pending;
        setSections(res.sections || []);
        setToolsMap(flattenTools(res.sections));
        setLoading(false);
    }, [request]);

    useEffect(() => { load(); }, [load]);

    const getManual = useCallback((toolKey) => toolsMap[toolKey] || null, [toolsMap]);

    return { sections, getManual, loading };
}
